export default {
  header: "List of Pizzas",
  view: "Pizza",
  pizzas: []
};
